import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import CodeEditor from './CodeEditor';
import ExecutionOutput from './ExecutionOutput';

const MobileWorkspace = ({ 
  code, 
  onChange, 
  language, 
  onLanguageChange, 
  onRun, 
  isRunning, 
  autoSave, 
  onToggleAutoSave,
  logs,
  screenshots,
  validationResults,
  executionMetrics
}) => {
  const [activePanel, setActivePanel] = useState('editor');

  const panels = [
    { id: 'editor', label: 'Editor', icon: 'Code' },
    { id: 'output', label: 'Output', icon: 'Terminal' }
  ];

  return (
    <div className="flex flex-col h-full">
      {/* Mobile Panel Switcher */}
      <div className="flex bg-card border-b border-subtle">
        {panels?.map((panel) => (
          <button
            key={panel?.id}
            onClick={() => setActivePanel(panel?.id)}
            className={`flex-1 flex items-center justify-center space-x-2 py-3 text-sm font-medium transition-colors ${
              activePanel === panel?.id
                ? 'text-primary bg-primary/10 border-b-2 border-primary' :'text-muted-foreground hover:text-foreground'
            }`}
          >
            <Icon name={panel?.icon} size={16} />
            <span>{panel?.label}</span>
          </button>
        ))}
      </div>
      {/* Panel Content */}
      <div className="flex-1 overflow-hidden">
        {activePanel === 'editor' && (
          <CodeEditor
            code={code}
            onChange={onChange}
            language={language}
            onLanguageChange={onLanguageChange}
            onRun={onRun}
            isRunning={isRunning}
            autoSave={autoSave}
            onToggleAutoSave={onToggleAutoSave}
          />
        )}

        {activePanel === 'output' && (
          <ExecutionOutput
            logs={logs}
            screenshots={screenshots}
            validationResults={validationResults}
            executionMetrics={executionMetrics}
            isRunning={isRunning}
          />
        )}
      </div>
      {/* Mobile Run Button (Floating) */}
      {activePanel === 'editor' && (
        <div className="absolute bottom-4 right-4">
          <Button
            variant="default"
            size="lg"
            iconName="Play"
            iconPosition="left"
            onClick={onRun}
            loading={isRunning}
            disabled={isRunning}
            className="shadow-elevation-2"
          >
            {isRunning ? 'Running...' : 'Run Code'}
          </Button>
        </div>
      )}
    </div>
  );
};

export default MobileWorkspace;